import { createClient } from '@supabase/supabase-js';
import { config } from './config.js';
export var supabase = createClient(config.supabaseUrl, config.supabaseAnonKey);
//# sourceMappingURL=client.js.map